import React from "react";
import {
  Image,
  Form,
  Button,
  Space,
  Row,
  Col,
  Upload,
  Modal,
  message,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import config from "../config";
import { UploadOutlined, CloseOutlined } from "@ant-design/icons";
import DeviceListStore from "../store/DeviceListStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import DeviceDetailsAdd from "./DeviceDetailsAdd";
// import editIcon from "../assets/images/NewDesign/editIcon.svg";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import uploadIcon from "../assets/images/NewDesign/upload.svg";
import sampleUploadIcon from "../assets/images/NewDesign/SampleUpload.svg";
import UploadTitleIcon from "../assets/images/NewDesign/UploadTitle.svg";
import uploadOutlined from "../assets/images/NewDesign/uploadOutlined.svg";
import sampleDownloadIcon from "../assets/images/NewDesign/SampleDownload.svg";
import axios from "axios";
import Cookies from "universal-cookie";
import { decode as base64_decode, encode as base64_encode } from "base-64";
const { Dragger } = Upload;
class DeviceList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.deviceListStore = new DeviceListStore();

    this.cookies = new Cookies();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      showUpload: false,
      openDeviceDetailsForm: false,
      Id: "",
      listDataUpdate: false,
      openDeleteModal: false,
      deleteData: {},
      editData: {},
    };

    this.columns = [
      {
        // title: "IMEI",
        title: context.translate("_FLEET_DASHBORD_SETTING_IMEI_"),
        dataIndex: "imeiNo",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("devicelist") && this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: "Model",
        title: context.translate("_FLEET_DASHBORD_VEHICLE_INFORMATION_MODEL_"),
        dataIndex: "model",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Shipment Date",
        title: context.translate("_SHIPMENT_DATE_"),
        dataIndex: "shipment",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Warranty Date",
        title: context.translate("_WARRANTY_DATE_"),
        dataIndex: "warranty",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Status",
        title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
        dataIndex: "stockstatus",
        width: 10,
        ellipsis: {
          showTitle: false,
        },
        render: (value, record) => {
          if (value === "Used") {
            return (
              <Tooltip
                title={`${context.translate("_VEHICLE_NO_")} ${
                  record.vehicleNo
                }`}
                color="green"
              >
                {value}
              </Tooltip>
            );
          } else if (value === "In Stock") {
            return (
              <Tooltip
                title={`${context.translate("_VEHICLE_NO_")} `}
                color="green"
              >
                {value}
              </Tooltip>
            );
          }
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        fixed: "right",
        align: "center",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("devicelist") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "14px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("devicelist") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "14px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];
  }

  onEdit = async (record) => {
    await this.setState({ Id: record.Id });
    await this.setState({ openDeviceDetailsForm: true });
  };

  async componentDidUpdate(prevProps, prevState) {
    if (
      Number(this.props.getUserData().isadmin) === 1 &&
      Number(this.props.getUserData().isadmin) === 0
    ) {
      this.props.navigate("/login");
    }
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    });
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      await this.deviceListStore.loadData({ offset: 0, limit: 50 });
      await this.setState({ listDataUpdate: false });
    }
  }
  async componentDidMount() {
    let tokendata = this.cookies.get("data")
      ? JSON.parse(base64_decode(this.cookies.get("data")))
      : "";
    const userToken = tokendata.userToken;
    this.setState({ token: userToken });
    await this.deviceListStore.loadData({ offset: 0, limit: 50 });
    this.setState({ pageSize: 50 });
  }

  uploadFunction = async ({ file, onSuccess, onError, onProgress }) => {
    try {
      const formData = new FormData();
      formData.append("excelFile", file);
      formData.append("fileType", "accountimport");
      formData.append("fieldName", "excelFile");

      const response = await axios.post(
        // config.baseURL + this.companyStore.fileUploadUrl,
        config.NodeUrl + "/deviceList/uploadDevice",
        formData,
        {
          headers: {
            token: this.state.token,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress({ percent });
          },
        }
      );

      onSuccess(response.data);
    } catch (error) {
      onError(error);
    }
  };

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination, "pagi");
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.deviceListStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      // total:2882
    });
    this.setState({ loading: false });
  }

  async onDelete(record) {
    console.log(record.Id, "record");
    const response = await this.deviceListStore.deleteRecord({
      Id: record.Id,
    });
    //  console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  responseMsg = async (resp) => {
    console.log(resp);
    if (resp.success == "S") {
      message.success(resp.message);
      await this.setState({ openDeviceDetailsForm: false });
      await this.setState({ listDataUpdate: true, currentPage: 1 });

      //  await this.handleSearch();
      // this.props.navigate("/devicelist");
    } else {
      message.error(resp.message);
    }
  };

  getUploadData = async (fileUp) => {
    let fileinfo = fileUp.file.response;

    console.log(fileinfo);

    if (fileinfo?.success == "S") {
      // console.log(fileinfo.data)

      await this.setState({ excelFile: fileinfo.data });
    }

    this.setState({ update: 1 });
  };

  onExcelSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      companyId: this.state.companyId,
      excelFile: this.state.excelFile,
    };

    if (data.excelFile) {
      const resp = await this.deviceListStore.addDeviceByExcel(data);
      if (resp?.success == "S") {
        message.success(resp.message);
        this.setState({ showUpload: false });
        this.setState({ excelFile: "" });
      } else {
        message.error(resp.message);
      }
    } else {
      message.error("Please Upload Excel File");
    }
  };

  closeModal = () => {
    this.setState({ openDeviceDetailsForm: false, Id: "" });
  };
  refreshList = async () => {
    this.setState({ loading: true });
    await this.deviceListStore.loadData({
      offset: 0,
      limit: 50,
    });
    this.setState({ loading: false, currentPage: 1 });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={24}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Tooltip
                  title={this.context.translate("_UPLOAD_")}
                  placement="bottom"
                >
                  <Button
                    className="uploadExcelButton"
                    onClick={() => this.setState({ showUpload: true })}
                  >
                    <Image
                      style={{
                        height: 18,
                      }}
                      src={uploadIcon}
                    />
                  </Button>
                </Tooltip>
                {this.props.canUpdate("devicelist") && (
                  <Button
                    className="addButtonClass"
                    onClick={() =>
                      this.setState({ openDeviceDetailsForm: true, Id: "" })
                    }
                  >
                    <Image
                      style={{ width: 13, marginInlineEnd: "5px" }} //marginInlineEnd: "5px",
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            // pagination={false}
            total={this.deviceListStore?.total}
            columns={this.columns}
            dataSource={this.deviceListStore?.deviceList}
            loading={this.deviceListStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {/* {this.state.showUpload && (
          <>
            {" "}
            <Modal
              open={this.state.showUpload}
              maskClosable={false}
              // title="File Upload"
              title={this.context.translate("_FILE_UPLOAD_")}
              onOk={() => this.setState({ showUpload: false })}
              onCancel={() => this.setState({ showUpload: false })}
              footer={false}
              width={400}
            >
              <Form
                name="excelimport"
                layout="vertical"
                onFinish={this.onExcelSubmit}
                style={{ maxWidth: "100%" }}
              >
                <Row>
                  <Col span={12}></Col>
                  <Col
                    span={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  ></Col>
                </Row>
                <Form.Item
                  name="excelFile"
                  // label="Excel File"
                  style={{ marginTop: "15px" }}
                  rules={[{ required: true }]}
                >
                  <Upload
                    name="excelFile"
                    action={
                      config.baseURL + "/index.php?c=company&a=fileupload"
                    }
                    listType="text"
                    data={{ fileType: "accountimport", fieldName: "excelFile" }}
                    onChange={this.getUploadData}
                    maxCount={1}
                  >
                    <Button icon={<UploadOutlined />}>
                     
                      {this.context.translate("_CLICKTOUPLOAD_EXCELFILE_")}
                    </Button>
                  </Upload>
                </Form.Item>
                <div className="formBtnGroup">
                  

                  <Button
                    className="formCancelButton"
                    // style={{ backgroundColor: config.activeColor }}
                    onClick={() => this.deviceListStore.sampleExcel()}
                  >
                    {this.context.translate("_SAMPLE_")}
                  
                  </Button>

                  <Button
                    type="primary"
                    className="formSaveButton"
                    htmlType="submit"
                  // loading={this.state.loading}
                  >
                    
                    {this.context.translate("_UPLOAD_")}
                  </Button>
                </div>
               
              </Form>
            </Modal>
          </>
        )} */}
        {this.state.showUpload && (
          <>
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.showUpload}
              placement={
                this.context.locale.language === "arabic" ? "left" : "right"
              }
              footer={false}
              title={
                <div className="uploadExcelTitle">
                  <Image
                    style={{ height: "60px" }}
                    src={UploadTitleIcon}
                  ></Image>
                  <span> {this.context.translate("_UPLOAD_EXCEL_TITLE_")}</span>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ showUpload: false })}
              onCancel={() =>
                this.setState({
                  showUpload: false,
                  excelFile: "",
                  companyId: "",
                })
              }
            >
              <Form
                name="excelimport"
                layout="vertical"
                onFinish={this.onExcelSubmit}
                style={{ margin: "16px 0px" }}
              >
                <Dragger
                  name="excelFile"
                  // action={"http://localhost:3005" + this.deviceListStore.fileUploadUrl}
                  // action={config.baseURL + this.deviceListStore.fileUploadUrl}
                  listType="text"
                  // data={{ fileType: "accountimport", fieldName: "excelFile" }}
                  customRequest={(options) => this.uploadFunction(options)}
                  onChange={this.getUploadData}
                  maxCount={1}
                  beforeUpload={(file) => {
                    const isExcel =
                      file.type === "application/vnd.ms-excel" ||
                      file.type ===
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

                    if (!isExcel) {
                      message.error(
                        "Only Excel files (.xls, .xlsx) are allowed!"
                      );
                      return Upload.LIST_IGNORE; // prevents the upload
                    }

                    return true;
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "20px",
                    }}
                  >
                    <div>
                      <Image
                        style={{ width: "90px" }}
                        src={uploadOutlined}
                      ></Image>
                    </div>
                    <div className="uploadFileText">
                      <span>
                        {this.context.translate("_UPLOAD_EXCEL_FILE_")}
                      </span>
                      <p>
                        {this.context.translate("_UPLOAD_TEXT_")}{" "}
                        <span
                          style={{
                            color: "var(--Blue-6, #1890FF)",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                        >
                          {this.context.translate("_UPLOAD_TEXT_1_")}{" "}
                        </span>
                        {this.context.translate("_UPLOAD_TEXT_2_")}
                      </p>
                    </div>
                  </div>
                </Dragger>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    textAlign: "center",
                    marginTop: "16px",
                  }}
                >
                  <div className="sampleDownload">
                    <span> {this.context.translate("_SAMPLE_DOWNLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_EXCEL_DESC_")}</p>
                    <Button onClick={() => this.deviceListStore.sampleExcel()}>
                      <Image src={sampleDownloadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {" "}
                        {this.context.translate("_SAMPLE_DOWNLOAD_")}
                      </span>
                    </Button>
                  </div>

                  <div className="sampleUpload">
                    <span> {this.context.translate("_SAMPLE_UPLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_DOWNLOAD_DESC_")}</p>
                    <Button>
                      <Image src={sampleUploadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {this.context.translate("_SAMPLE_UPLOAD_")}
                      </span>{" "}
                    </Button>
                  </div>
                </div>

                <Space className="uploadFooter">
                  <Button
                    className="uploadCancelButton"
                    onClick={() =>
                      this.setState({
                        showUpload: false,
                        excelFile: "",
                        companyId: "",
                      })
                    }
                  >
                    {this.context.translate(
                      "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                    )}
                  </Button>
                  <Button htmlType="submit" className="uploadButton">
                    {this.context.translate("_UPLOAD_")}
                  </Button>
                </Space>
              </Form>
            </Drawer>{" "}
          </>
        )}
        {this.state.openDeviceDetailsForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openDeviceDetailsForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_DEVICE_DETAIL_")}
                <p className="formDescription">
                  {this.context.translate("_DEVICE_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openDeviceDetailsForm: false })}
            onCancel={() =>
              this.setState({ openDeviceDetailsForm: false, Id: "" })
            }
          >
            <div style={{ height: "100%" }}>
              {this.state.openDeviceDetailsForm && (
                <DeviceDetailsAdd
                  Id={this.state.Id}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              )}
            </div>
          </Drawer>
        )}
        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
DeviceList.contextType = StoreContext;
export default observer(withRouter(DeviceList));
